/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

import {adnTranslate} from './adn-translate';
import {interpolateTemplate} from './interpolate-template';

@Injectable({providedIn: 'root'})
export class AdnTranslateService {
  constructor(private readonly translate: TranslateService) {
  }

  transform(message: string, code: string, params?: any): string {
    return adnTranslate(
      message,
      code,
      params,
      (key, p) => this.translate.instant(key, p),
      interpolateTemplate
    );
  }
}
